"use client";

export default function Services() {
  return <section data-section-id="681" id="japaneselanguageservices" className="relative bg-background py-20 md:py-28 lg:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-sm font-semibold uppercase tracking-widest text-secondary mb-5">
            日本語対応
          </p>
          <h2 className="font-default text-4xl sm:text-5xl lg:text-[3.5rem] font-bold leading-[1.05] text-foreground mb-6">
            日本語での初期連絡・情報整理に<span className="italic text-secondary">対応</span>
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed mb-6">
            当事務所では、日本語による初期のお問い合わせおよびご相談内容の情報整理を承っております。フロリダ州におけるビジネス、不動産、相続などの法的手続きに関して、言葉の不安を軽減し、スムーズなコミュニケーションをサポートいたします。
          </p>
          <p className="text-base text-muted-foreground leading-relaxed mb-8">
            最初のヒアリングや資料の整理を日本語で行った上で、弁護士による本格的な法的助言や代理業務へと移行します。
          </p>
          <div className="bg-card border border-border rounded-xl p-6 md:p-8 shadow-sm mb-6 text-left">
            <p className="text-sm text-muted-foreground leading-relaxed">
              <strong>法的助言に関するご注意:</strong> 初期の日本語によるお問合せおよび情報整理・翻訳サポートは、円滑な意思疎通のための補助として提供されるものであり、それ自体が法的な助言や代理人を構成するものではありません。正式な法的助言、合意書の作成、および法的手続きの代理は、担当弁護士の受任確認および正式な委任契約の締結後に開始されます。
            </p>
          </div>
          <p className="text-sm text-secondary font-medium">
            日本語でのお問い合わせを受け付けています。
          </p>
        </div>
      </div>
    </section>;
}